<div
  [class]="mixedMode() ? 'h-full' : 'px-6 py-3 bg-[#f9fafb] dark:bg-surface-0 min-h-screen rounded-xl backdrop-blur-xl border border-gray-300/60 dark:border-gray-700'">
  @if (!mixedMode()) {
  <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3 mb-6 [@media(max-height:620px)]:mb-3">
    <h1 class="text-xl font-bold text-gray-800 dark:text-white">Practina Dashboard</h1>
    <div class="flex flex-wrap items-center gap-3 justify-end">
      <app-date-picker [showComparison]="false" [value]="initialDateValue"
        (dateRangeChange)="onDateRangeChange($event)"></app-date-picker>
      <button type="button" (click)="openCustomizeLayout()"
        class="flex items-center gap-1.5 px-3 py-2 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm font-medium hover:border-[#AD46FF]/60 hover:text-[#AD46FF] transition-all duration-200 shadow-sm whitespace-nowrap">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect width="7" height="7" x="3" y="3" rx="1" />
          <rect width="7" height="7" x="14" y="3" rx="1" />
          <rect width="7" height="7" x="14" y="14" rx="1" />
          <rect width="7" height="7" x="3" y="14" rx="1" />
        </svg>
        Customize layout
      </button>
    </div>
  </div>
  }

  <ng-template #sectionPin let-sectionId>
    @if (!mixedMode()) {
    <button type="button" (click)="addToCustomDashboard(sectionId); $event.stopPropagation()"
      [disabled]="isAddingToCustomDashboard(sectionId)"
      class="group/pin absolute cursor-pointer top-2 right-2 z-20 inline-flex items-center gap-1.5 h-7 px-2.5 rounded-full border shadow-sm text-[11px] font-medium whitespace-nowrap opacity-0 translate-y-[-2px] group-hover:opacity-100 group-hover:translate-y-0 focus-visible:opacity-100 focus-visible:translate-y-0 transition-all duration-200 disabled:cursor-default"
      [ngClass]="isAddedToCustomDashboard(sectionId)
          ? 'bg-emerald-50 text-emerald-700 border-emerald-200 hover:bg-rose-50 hover:text-rose-700 hover:border-rose-200 dark:bg-emerald-900/30 dark:text-emerald-300 dark:border-emerald-800 dark:hover:bg-rose-900/30 dark:hover:text-rose-300 dark:hover:border-rose-800 !opacity-100 !translate-y-0'
          : 'bg-white/95 text-[#AD46FF] border-[#AD46FF]/30 hover:bg-violet-50 hover:border-[#AD46FF]/60 hover:shadow-md dark:bg-slate-800/95 dark:border-purple-500/40 dark:hover:bg-white/5'"
      [attr.aria-label]="isAddedToCustomDashboard(sectionId) ? 'Remove from My Custom Dashboard' : 'Add to My Custom Dashboard'"
      [title]="isAddedToCustomDashboard(sectionId) ? 'Click to remove from My Custom Dashboard' : 'Add to My Custom Dashboard'">
      @if (isAddingToCustomDashboard(sectionId)) {
      <svg class="animate-spin" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M21 12a9 9 0 1 1-6.219-8.56" />
      </svg>
      <span>{{ isAddedToCustomDashboard(sectionId) ? 'Removing' : 'Adding' }}&hellip;</span>
      } @else if (isAddedToCustomDashboard(sectionId)) {
      <svg class="shrink-0 block group-hover/pin:hidden" xmlns="http://www.w3.org/2000/svg" width="11" height="11"
        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round"
        stroke-linejoin="round">
        <path d="M20 6 9 17l-5-5" />
      </svg>
      <svg class="shrink-0 hidden group-hover/pin:block" xmlns="http://www.w3.org/2000/svg" width="11" height="11"
        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round"
        stroke-linejoin="round">
        <path d="M5 12h14" />
      </svg>
      <span
        class="inline-block max-w-0 -ml-1.5 group-hover/pin:max-w-[220px] group-hover/pin:ml-0 focus-visible:max-w-[220px] focus-visible:ml-0 overflow-hidden whitespace-nowrap transition-all duration-300 ease-out">Remove
        from Custom Dashboard</span>
      } @else {
      <svg class="shrink-0" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round">
        <path d="M5 12h14" />
        <path d="M12 5v14" />
      </svg>
      <span
        class="inline-block max-w-0 -ml-1.5 group-hover/pin:max-w-[200px] group-hover/pin:ml-0 focus-visible:max-w-[200px] focus-visible:ml-0 overflow-hidden whitespace-nowrap transition-all duration-300 ease-out">Pin
        to Custom Dashboard</span>
      }
    </button>
    }
  </ng-template>

  <div [class]="mixedMode() ? 'unified-tile-body h-full' : ''">
    <div class="grid grid-cols-12 gap-4 [@media(max-height:620px)]:gap-2 grid-flow-row-dense"
      [class.gap-0]="mixedMode()">

      @if (showSection(SectionId.ACQUISITION)) {
      <div class="flex flex-col gap-3 [@media(max-height:620px)]:gap-1.5 relative group"
        [ngClass]="getSectionColClass(SectionId.ACQUISITION)" [style.order]="sectionOrder(SectionId.ACQUISITION)">
        <ng-container *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.ACQUISITION }"></ng-container>
        <div class="flex flex-col gap-3 [@media(max-height:620px)]:gap-1.5">
          <ng-container
            *ngTemplateOutlet="clampedH2; context: { text: 'Acquisition', classes: sectionHeadingClass }"></ng-container>
          <div class="grid grid-cols-2 w-full gap-3 [@media(max-height:620px)]:gap-1.5">
            @for (card of acquisitionCards; track card.title) {
            <ng-container *ngTemplateOutlet="cardTemplate; context: { $implicit: card }"></ng-container>
            }
          </div>
        </div>
      </div>
      }
      @if (showSection(SectionId.CONVERSION)) {
      <div class="flex flex-col gap-3 [@media(max-height:620px)]:gap-1.5 relative group"
        [ngClass]="getSectionColClass(SectionId.CONVERSION)" [style.order]="sectionOrder(SectionId.CONVERSION)">
        <ng-container *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.CONVERSION }"></ng-container>
        <div class="flex flex-col gap-3 [@media(max-height:620px)]:gap-1.5">
          <ng-container
            *ngTemplateOutlet="clampedH2; context: { text: 'Conversion', classes: sectionHeadingClass }"></ng-container>
          <div class="grid grid-cols-3 w-full gap-3 [@media(max-height:620px)]:gap-1.5">
            @for (card of conversionCards; track card.title) {
            <ng-container *ngTemplateOutlet="cardTemplate; context: { $implicit: card }"></ng-container>
            }
          </div>
        </div>
      </div>
      }

      @if (showSection(SectionId.SUBSCRIPTIONS)) {
      <div class="flex flex-col w-full gap-3 [@media(max-height:620px)]:gap-1.5 relative group"
        [ngClass]="getSectionColClass(SectionId.SUBSCRIPTIONS)" [style.order]="sectionOrder(SectionId.SUBSCRIPTIONS)">
        <ng-container *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.SUBSCRIPTIONS }"></ng-container>
        <div class="flex flex-col w-full gap-3 [@media(max-height:620px)]:gap-1.5">
          <ng-container
            *ngTemplateOutlet="clampedH2; context: { text: 'Subscriptions', classes: sectionHeadingClass }"></ng-container>
          <div
            class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 w-full gap-3 [@media(max-height:620px)]:gap-2">
            @for (card of subscriptionCards; track card.title) {
            <ng-container *ngTemplateOutlet="cardTemplate; context: { $implicit: card }"></ng-container>
            }
          </div>
        </div>
      </div>
      }

      @if (showSection(SectionId.MONTHLY_SIGNUP_TREND)) {
      <div class="relative group" [ngClass]="getSectionColClass(SectionId.MONTHLY_SIGNUP_TREND)"
        [style.order]="sectionOrder(SectionId.MONTHLY_SIGNUP_TREND)">
        <ng-container
          *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.MONTHLY_SIGNUP_TREND }"></ng-container>
        <div [ngClass]="chartSectionShellClass()">
          <ng-container
            *ngTemplateOutlet="clampedH3; context: { text: 'Monthly Signup Trend (Total vs Social)', classes: chartHeadingClass }"></ng-container>
          <p class="text-[13px] text-gray-500 dark:text-gray-400 mb-4 font-medium">Comparing total new signups against
            social-driven growth</p>
          <div class="flex-1 relative min-h-0">
            @if (loadingSignupTrend) {
            <app-individual-toaster [message]="'Loading acquisition trend...'" [position]="'top-center'" [type]="'info'"
              [loaderType]="'dark'" [fontSize]="'24px'"></app-individual-toaster>
            } @else if (!hasMonthlySignupTrendData) {
            <div class="absolute inset-0 flex flex-col items-center justify-center text-slate-400 dark:text-slate-500">
              <app-icon-v2 name="database" [size]="48" class="mb-3 opacity-50"></app-icon-v2>
              <p class="text-sm font-medium">No data available</p>
              <p class="text-xs mt-1">There are no records for this period.</p>
            </div>
            } @else {
            <div class="w-full h-full flex flex-col">
              <div class="flex-1 flex items-center justify-center">
                <app-line-area-chart [series]="monthlySignupTrendData" [height]="embeddedChartHeight(330)"
                  [dateUnit]="currentTimeUnit" [margins]="{ top: 40, right: 30, bottom: 50, left: 60 }"
                  [cardPadding]="'0'" [showCard]="false" [useDualYAxis]="false" [darkThemeClass]="'dark:bg-surface-2'"
                  [curveType]="'linear'" [yAxis]="{show: true, showGrid: true, showAxisLine: true, gridStyle: 'dashed'}"
                  [xAxisPadding]="10"
                  [xAxis]="{show: true, showAxisLine: true, showGrid: false, showOnlyFirstLast: true, showAllLabels: true, tickFormat: formatTick, showTicks: false}"
                  [legend]="{ show: true, position: 'bottom' }" [renderLegendInSvg]="true" [legendGap]="100"
                  [legendData]="[{label: 'Total Signups', color: '#1d4ed8'}, {label: 'Social Signups', color: '#f59e0b'}]"
                  [expandMonthDomain]="false">
                </app-line-area-chart>
              </div>
            </div>
            }
          </div>
        </div>
      </div>
      }
      @if (showSection(SectionId.PROFILE_COMPLETION)) {
      <div class="relative group" [ngClass]="getSectionColClass(SectionId.PROFILE_COMPLETION)"
        [style.order]="sectionOrder(SectionId.PROFILE_COMPLETION)">
        <ng-container
          *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.PROFILE_COMPLETION }"></ng-container>
        <div [ngClass]="chartSectionShellClass()">
          <ng-container
            *ngTemplateOutlet="clampedH3; context: { text: 'Profile vs Onboarding Completion', classes: chartHeadingClass }"></ng-container>
          <p class="text-[13px] text-gray-500 dark:text-gray-400 mb-4 font-medium">Profile and onboarding completions by
            period</p>
          <div class="flex-1 relative min-h-0">
            @if (loadingProfileCompletion) {
            <app-individual-toaster [message]="'Loading profile completion...'" [position]="'top-center'"
              [type]="'info'" [loaderType]="'dark'" [fontSize]="'24px'"></app-individual-toaster>
            } @else if (!hasProfileCompletionData) {
            <div class="absolute inset-0 flex flex-col items-center justify-center text-slate-400 dark:text-slate-500">
              <app-icon-v2 name="database" [size]="48" class="mb-3 opacity-50"></app-icon-v2>
              <p class="text-sm font-medium">No data available</p>
              <p class="text-xs mt-1">There are no records for this period.</p>
            </div>
            } @else {
            <div class="w-full h-full flex flex-col">
              <div class="flex-1 flex items-center justify-center">
                <app-cylinder-chart class="w-full h-full" [data]="profileCompletionData"
                  [height]="embeddedChartHeight(330)" [margins]="{ top: 40, right: 30, bottom: 50, left: 60 }"
                  [xAxisPadding]="10" [showLegend]="true" [legendGap]="60"
                  [legendData]="[{label: 'Business Profile Complete', color: '#c084fc'}, {label: 'Onboarding Complete', color: '#10b981'}]"
                  [width]="embeddedCylinderWidth()" [barWidth]="20" [showGrid]="true" [showYAxis]="true"
                  [showTooltip]="true" [showValuesOnBars]="false" [showXAxisLine]="true" [innerPadding]="0"
                  [fitBarToBandwidth]="true" [maxBarWidth]="30" [xAxisShowOnlyFirstLast]="true" [showBgRect]="false"
                  [showYAxisLine]="true">
                </app-cylinder-chart>
              </div>
            </div>
            }
          </div>
        </div>
      </div>
      }

      @if (showSection(SectionId.SIGNUP_REVENUE_FUNNEL)) {
      <div class="relative group" [ngClass]="getSectionColClass(SectionId.SIGNUP_REVENUE_FUNNEL)"
        [style.order]="sectionOrder(SectionId.SIGNUP_REVENUE_FUNNEL)">
        <ng-container
          *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.SIGNUP_REVENUE_FUNNEL }"></ng-container>
        <div [ngClass]="chartSectionShellClass()">
          <ng-container
            *ngTemplateOutlet="clampedH3; context: { text: 'Signup to Revenue Journey', classes: chartHeadingClass }"></ng-container>
          <p class="text-[13px] text-gray-500 dark:text-gray-400 mb-4 font-medium">Tracking user progression from
            acquisition to revenue</p>
          <div class="flex-1 relative min-h-0">
            @if (loadingFunnel) {
            <app-individual-toaster [message]="'Loading funnel journey...'" [position]="'top-center'" [type]="'info'"
              [loaderType]="'dark'" [fontSize]="'24px'"></app-individual-toaster>
            } @else if (!hasSignupToRevenueFunnelData) {
            <div class="absolute inset-0 flex flex-col items-center justify-center text-slate-400 dark:text-slate-500">
              <app-icon-v2 name="database" [size]="48" class="mb-3 opacity-50"></app-icon-v2>
              <p class="text-sm font-medium">No data available</p>
              <p class="text-xs mt-1">There are no records for this period.</p>
            </div>
            } @else {
            <div class="w-full h-full flex items-center justify-center">
              <app-funnel-chart [data]="signupToRevenueFunnel" [height]="'300px'" [width]="'100%'" [showBorder]="false"
                [showShadow]="false" [showLegends]="false" [showLeftLabel]="false" [showRightLabel]="true"
                [rightAlignLabels]="true" [funnelShape]="'pipeline'" [isContinuous]="true" [showCenterLabels]="false"
                [padding]="'0 0'" [margins]="{top: 20, right: 180, bottom: 20, left: 20}" [showPercentage]="false"
                [darkThemeClass]="'dark:bg-surface-2'" [config]="{ title: '', barStyle: 'solid' }"
                class="block mx-auto max-w-[550px]">
              </app-funnel-chart>
            </div>
            }
          </div>
        </div>
      </div>
      }
      @if (showSection(SectionId.CONVERSION_MONETIZATION)) {
      <div class="relative group" [ngClass]="getSectionColClass(SectionId.CONVERSION_MONETIZATION)"
        [style.order]="sectionOrder(SectionId.CONVERSION_MONETIZATION)">
        <ng-container
          *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.CONVERSION_MONETIZATION }"></ng-container>
        <div [ngClass]="chartSectionShellClass()">
          <ng-container
            *ngTemplateOutlet="clampedH3; context: { text: 'User Conversion & Monetization Trend', classes: chartHeadingClass }"></ng-container>
          <p class="text-[13px] text-gray-500 dark:text-gray-400 mb-4 font-medium">Monthly progression of Trials,
            Freemium users, and Paid conversions</p>
          <div class="flex-1 relative min-h-0">
            @if (loadingConversionTrend) {
            <app-individual-toaster [message]="'Loading conversion trend...'" [position]="'top-center'" [type]="'info'"
              [loaderType]="'dark'" [fontSize]="'24px'"></app-individual-toaster>
            } @else if (!hasConversionTrendData) {
            <div class="absolute inset-0 flex flex-col items-center justify-center text-slate-400 dark:text-slate-500">
              <app-icon-v2 name="database" [size]="48" class="mb-3 opacity-50"></app-icon-v2>
              <p class="text-sm font-medium">No data available</p>
              <p class="text-xs mt-1">There are no records for this period.</p>
            </div>
            } @else {
            <div class="absolute inset-0">
              <app-line-area-chart [series]="conversionTrendData" [height]="'auto'" [dateUnit]="currentTimeUnit"
                [margins]="{ top: 20, right: 20, bottom: 50, left: 60 }" [cardPadding]="'0'" [showCard]="false"
                [useDualYAxis]="false" [darkThemeClass]="'dark:bg-surface-2'" [curveType]="'catmullRom'"
                [yAxis]="{show: true, showGrid: true, showAxisLine: true, gridStyle: 'dashed'}"
                [xAxis]="{show: true, showAxisLine: true, showGrid: false, showOnlyFirstLast: true, showAllLabels: true, tickFormat: formatTick, showTicks: true}"
                [legend]="{ show: true, position: 'bottom' }" [expandMonthDomain]="false" class="w-full h-full block">
              </app-line-area-chart>
            </div>
            }
          </div>
        </div>
      </div>
      }

      @if (showSection(SectionId.CONVERSION_PIPELINE)) {
      <div class="relative group" [ngClass]="getSectionColClass(SectionId.CONVERSION_PIPELINE)"
        [style.order]="sectionOrder(SectionId.CONVERSION_PIPELINE)">
        <ng-container
          *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.CONVERSION_PIPELINE }"></ng-container>
        <div [ngClass]="chartSectionShellClass(true)">
          <ng-container
            *ngTemplateOutlet="clampedH3; context: { text: 'Conversion Pipeline', classes: chartHeadingClass }"></ng-container>
          <p class="text-[13px] text-gray-500 dark:text-gray-400 mb-4 font-medium">Trial & Freemium Conversions vs
            Cancellations</p>
          <div class="flex-1 relative min-h-0 flex flex-col">
            @if (loadingConversionPipeline) {
            <app-individual-toaster [message]="'Loading conversion pipeline...'" [position]="'top-center'"
              [type]="'info'" [loaderType]="'dark'" [fontSize]="'24px'"></app-individual-toaster>
            } @else if (!hasConversionPipelineData) {
            <div class="absolute inset-0 flex flex-col items-center justify-center text-slate-400 dark:text-slate-500">
              <app-icon-v2 name="database" [size]="48" class="mb-3 opacity-50"></app-icon-v2>
              <p class="text-sm font-medium">No data available</p>
              <p class="text-xs mt-1">There are no records for this period.</p>
            </div>
            } @else {
            <div class="flex-1 flex items-center justify-center">
              <app-isometric-bar [data]="conversionPipelineData" [width]="'auto'" [height]="'auto'" [barWidth]="20"
                [barDepth]="12" [angle]="30" [showGrid]="true" [showLegend]="true" [innerPadding]="0"
                [fitBarToBandwidth]="true" [maxBarWidth]="40"
                [legendData]="[{label: 'Trial → Paid', color: '#fcd34d'}, {label: 'Free → Paid', color: '#60a5fa'}, {label: 'Cancellations', color: '#f87171'}]"
                [showYAxis]="true" [showTooltip]="true" [showBarValues]="false" [showXAxisLine]="true"
                [showYAxisLine]="true" [topHighlightFactor]="0.4" [showPercentage]="false"
                [xAxisShowOnlyFirstLast]="true" [showBgRect]="false" [reducedHighlight]="true"
                [margins]="{ top: 40, right: 20, bottom: 50, left: 60 }" class="w-full h-full block">
              </app-isometric-bar>
            </div>
            }
          </div>
        </div>
      </div>
      }

      @if (showSection(SectionId.RENEWAL_TREND)) {
      <div class="relative group" [ngClass]="getSectionColClass(SectionId.RENEWAL_TREND)"
        [style.order]="sectionOrder(SectionId.RENEWAL_TREND)">
        <ng-container *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.RENEWAL_TREND }"></ng-container>
        <div [ngClass]="chartSectionShellClass()">
          <ng-container
            *ngTemplateOutlet="clampedH3; context: { text: 'Renewal & Payment Stability', classes: chartHeadingClass }"></ng-container>
          <p class="text-[13px] text-gray-500 dark:text-gray-400 mb-4 font-medium">Auto-renew success versus payment
            failure risk</p>
          <div class="flex-1 relative min-h-0">
            @if (loadingRenewalTrend) {
            <app-individual-toaster [message]="'Loading renewal trend...'" [position]="'top-center'" [type]="'info'"
              [loaderType]="'dark'" [fontSize]="'24px'"></app-individual-toaster>
            } @else if (!hasRenewalTrendData) {
            <div class="absolute inset-0 flex flex-col items-center justify-center text-slate-400 dark:text-slate-500">
              <app-icon-v2 name="database" [size]="48" class="mb-3 opacity-50"></app-icon-v2>
              <p class="text-sm font-medium">No data available</p>
              <p class="text-xs mt-1">There are no records for this period.</p>
            </div>
            } @else {
            <div class="absolute inset-0">
              <app-line-area-chart [series]="renewalTrendData" [height]="'auto'" [dateUnit]="currentTimeUnit"
                [margins]="{ top: 20, right: 20, bottom: 50, left: 60 }" [cardPadding]="'0'" [showCard]="false"
                [xAxisPadding]="20" [useDualYAxis]="false" [darkThemeClass]="'dark:bg-surface-2'" [curveType]="'linear'"
                [yAxis]="{show: true, showGrid: true, showAxisLine: true, gridStyle: 'dashed'}"
                [xAxis]="{show: true, showAxisLine: true, showGrid: false, showOnlyFirstLast: true, showAllLabels: true, tickFormat: formatTick, showTicks: true}"
                [legend]="{ show: true, position: 'bottom' }" class="w-full h-full block">
              </app-line-area-chart>
            </div>
            }
          </div>
        </div>
      </div>
      }
      @if (showSection(SectionId.AI_CONTENT_TREND)) {
      <div class="relative group" [ngClass]="getSectionColClass(SectionId.AI_CONTENT_TREND)"
        [style.order]="sectionOrder(SectionId.AI_CONTENT_TREND)">
        <ng-container *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.AI_CONTENT_TREND }"></ng-container>
        <div [ngClass]="chartSectionShellClass()">
          <ng-container
            *ngTemplateOutlet="clampedH3; context: { text: 'AI Content Contribution Trend', classes: chartHeadingClass }"></ng-container>
          <p class="text-[13px] text-gray-500 dark:text-gray-400 mb-4 font-medium">AI-generated posts relative to total
            publishing volume</p>
          <div class="flex-1 relative min-h-0">
            @if (loadingAiContent) {
            <app-individual-toaster [message]="'Loading content trend...'" [position]="'top-center'" [type]="'info'"
              [loaderType]="'dark'" [fontSize]="'24px'"></app-individual-toaster>
            } @else if (!hasAiContentTrendData) {
            <div class="absolute inset-0 flex flex-col items-center justify-center text-slate-400 dark:text-slate-500">
              <app-icon-v2 name="database" [size]="48" class="mb-3 opacity-50"></app-icon-v2>
              <p class="text-sm font-medium">No data available</p>
              <p class="text-xs mt-1">There are no records for this period.</p>
            </div>
            } @else {
            <div class="absolute inset-0">
              <app-line-area-chart class="w-full h-full block" [series]="aiContentTrendData"
                [xAxis]="{ show: true, showGrid: false, showAxisLine: true, showOnlyFirstLast: true, showAllLabels: true, tickFormat: formatTick, showTicks: true }"
                [yAxis]="{ show: true, showGrid: true, showAxisLine: true, gridStyle: 'dashed' }" [height]="'auto'"
                [margins]="{ top: 40, right: 20, bottom: 50, left: 60 }" [useStandardizedLegend]="true"
                [legend]="{ show: true, position: 'bottom', align: 'center', itemGap: 24 }" [dateUnit]="currentTimeUnit"
                [cardPadding]="'0'" [showCard]="false" [expandMonthDomain]="false" [useDualYAxis]="false"
                [darkThemeClass]="'dark:bg-surface-2'" [curveType]="'catmullRom'">
              </app-line-area-chart>
            </div>
            }
          </div>
        </div>
      </div>
      }

      @if (showSection(SectionId.AD_LEADS_CAMPAIGN)) {
      <div class="relative group" [ngClass]="getSectionColClass(SectionId.AD_LEADS_CAMPAIGN)"
        [style.order]="sectionOrder(SectionId.AD_LEADS_CAMPAIGN)">
        <ng-container
          *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.AD_LEADS_CAMPAIGN }"></ng-container>
        <div [ngClass]="chartSectionShellClass()">
          <ng-container
            *ngTemplateOutlet="clampedH3; context: { text: 'Ad Leads & Campaign Activity', classes: chartHeadingClass }"></ng-container>
          <p class="text-[13px] text-gray-500 dark:text-gray-400 mb-4 font-medium">Leads/ad ratio performance</p>
          <div class="flex-1 relative min-h-0">
            @if (loadingAdLeads) {
            <app-individual-toaster [message]="'Loading campaign activity...'" [position]="'top-center'" [type]="'info'"
              [loaderType]="'dark'" [fontSize]="'24px'"></app-individual-toaster>
            } @else if (!hasAdLeadsCampaignData) {
            <div class="absolute inset-0 flex flex-col items-center justify-center text-slate-400 dark:text-slate-500">
              <app-icon-v2 name="database" [size]="48" class="mb-3 opacity-50"></app-icon-v2>
              <p class="text-sm font-medium">No data available</p>
              <p class="text-xs mt-1">There are no records for this period.</p>
            </div>
            } @else {
            <div class="w-full h-full overflow-x-auto custom-scrollbar flex items-center"
              [class.justify-center]="durationDays() <= 730">
              <div [ngStyle]="{'min-width': durationDays() > 730 ? (adLeadsData.length * 120) + 'px' : '100%'}"
                class="h-full w-full">
                <app-multiple-bar [data1]="adLeadsData" [data2]="activeAdsData" [data3]="aiCampaignsData"
                  [legendData]="[{ label: 'Ad Leads', color: '#c084fc' }, { label: 'Active Ads', color: '#60a5fa' }, { label: 'AI Campaigns Created', color: '#10b981' }]"
                  [legendPosition]="'center'" [legendGap]="100"
                  [colors]="{ data1: '#c084fc', data2: '#60a5fa', data3: '#10b981', data4: '' }"
                  [showDynamicxAxisLabel]="true" [addGradient]="true" [barClusterPixel]="30" [valueType]="'number'"
                  [valueKey]="'value'" [xAxisShowOnlyFirstLast]="durationDays() <= 730" [showBgRect]="false"
                  [barHeightRatio]="0.75" [height]="embeddedChartHeight(330)" [useStandardizedScaling]="true"
                  [margin]="{ top: 40, right: 30, bottom: 50, left: 60 }" class="w-full h-full block">
                </app-multiple-bar>
              </div>
            </div>
            }
          </div>
        </div>
      </div>
      }

      @if (showSection(SectionId.PLATFORM_POST_DISTRIBUTION)) {
      <div class="relative group" [ngClass]="getSectionColClass(SectionId.PLATFORM_POST_DISTRIBUTION)"
        [style.order]="sectionOrder(SectionId.PLATFORM_POST_DISTRIBUTION)">
        <ng-container
          *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.PLATFORM_POST_DISTRIBUTION }"></ng-container>
        <div [ngClass]="metricSectionShellClass()">
          <ng-container
            *ngTemplateOutlet="clampedH3; context: { text: 'User Content Distribution', classes: chartHeadingClass }"></ng-container>
          <p class="text-[13px] text-gray-500 dark:text-gray-400 mb-4 font-medium">Post distribution across different
            platforms</p>
          <div class="flex-1 relative min-h-0">
            @if (loadingPlatformPosts) {
            <app-individual-toaster [message]="'Loading distribution...'" [position]="'top-center'" [type]="'info'"
              [loaderType]="'dark'" [fontSize]="'24px'"></app-individual-toaster>
            } @else if (!hasPlatformPostDistributionData) {
            <div class="absolute inset-0 flex flex-col items-center justify-center text-slate-400 dark:text-slate-500">
              <app-icon-v2 name="database" [size]="48" class="mb-3 opacity-50"></app-icon-v2>
              <p class="text-sm font-medium">No data available</p>
              <p class="text-xs mt-1">There are no records for this period.</p>
            </div>
            } @else {
            <div class="absolute inset-0 flex items-center justify-center">
              <app-pie-chart [data]="userConversionPieData" [is3d]="false" [width]="'auto'" [height]="'auto'"
                [showLegend]="false" [isDonut]="true" [donutRadiusRatio]="0.55" [showPolylines]="true"
                [polylineValueFormat]="'value'" [centerLabel]="'Total'" [useParentHeight]="true"
                [centerValue]="centerValue" [fitToContainer]="true" [tightViewBox]="true" class="block w-full h-full">
              </app-pie-chart>
            </div>
            }
          </div>
        </div>
      </div>
      }
      @if (showSection(SectionId.AD_SPEND_CHANNEL)) {
      <div class="relative group" [ngClass]="getSectionColClass(SectionId.AD_SPEND_CHANNEL)"
        [style.order]="sectionOrder(SectionId.AD_SPEND_CHANNEL)">
        <ng-container *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.AD_SPEND_CHANNEL }"></ng-container>
        <div [ngClass]="metricSectionShellClass()">
          <ng-container
            *ngTemplateOutlet="clampedH3; context: { text: 'Ad Spend by Channel', classes: chartHeadingClass }"></ng-container>
          <p class="text-[13px] text-gray-500 dark:text-gray-400 mb-4 font-medium">Budget leadership over time</p>
          <div class="flex-1 relative min-h-0">
            @if (loadingAdSpend) {
            <app-individual-toaster [message]="'Loading ad spend...'" [position]="'top-center'" [type]="'info'"
              [loaderType]="'dark'" [fontSize]="'24px'"></app-individual-toaster>
            } @else if (!hasAdSpendData) {
            <div class="absolute inset-0 flex flex-col items-center justify-center text-slate-400 dark:text-slate-500">
              <app-icon-v2 name="database" [size]="48" class="mb-3 opacity-50"></app-icon-v2>
              <p class="text-sm font-medium">No data available</p>
              <p class="text-xs mt-1">There are no records for this period.</p>
            </div>
            } @else {
            <div class="absolute inset-0">
              <app-line-area-chart [series]="adSpendTrendData" [height]="'auto'" [dateUnit]="currentTimeUnit"
                [margins]="{ top: 20, right: 20, bottom: 50, left: 40 }" [cardPadding]="'0'" [showCard]="false"
                [useDualYAxis]="false" [darkThemeClass]="'dark:bg-surface-2'" [curveType]="'linear'"
                [expandMonthDomain]="false"
                [yAxis]="{show: true, showGrid: true, showAxisLine: true, gridStyle: 'dotted', tickCount: 5}"
                [xAxis]="{show: true, showAxisLine: true, showGrid: true, gridStyle: 'dotted', showOnlyFirstLast: true, showAllLabels: true, tickFormat: formatTick}"
                [legend]="{ show: true, position: 'bottom' }" class="w-full h-full block">
              </app-line-area-chart>
            </div>
            }
          </div>
        </div>
      </div>
      }

      @if (showSection(SectionId.DEMO_SIGNUP_TREND)) {
      <div class="relative group" [ngClass]="getSectionColClass(SectionId.DEMO_SIGNUP_TREND)"
        [style.order]="sectionOrder(SectionId.DEMO_SIGNUP_TREND)">
        <ng-container
          *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.DEMO_SIGNUP_TREND }"></ng-container>
        <div [ngClass]="metricSectionShellClass()">
          <ng-container
            *ngTemplateOutlet="clampedH3; context: { text: 'Demo-to-Signup Conversion Trend', classes: chartHeadingClass }"></ng-container>
          <p class="text-[13px] text-gray-500 dark:text-gray-400 mb-4 font-medium">Post demo registrations performance
          </p>
          <div class="flex-1 relative min-h-0">
            @if (loadingDemoSignup) {
            <app-individual-toaster [message]="'Loading demo conversion...'" [position]="'top-center'" [type]="'info'"
              [loaderType]="'dark'" [fontSize]="'24px'"></app-individual-toaster>
            } @else if (!hasDemoSignupData) {
            <div class="absolute inset-0 flex flex-col items-center justify-center text-slate-400 dark:text-slate-500">
              <app-icon-v2 name="database" [size]="48" class="mb-3 opacity-50"></app-icon-v2>
              <p class="text-sm font-medium">No data available</p>
              <p class="text-xs mt-1">There are no records for this period.</p>
            </div>
            } @else {
            <div class="w-full h-full flex items-center justify-center">
              <app-stacked-bar [data]="demoSignupData" [width]="540" [height]="'auto'" [bottomColor]="'#f59e0b'"
                [topColor]="'#34d399'" [topLabel]="'Remaining Demos'" [bottomLabel]="'Self Registrations'"
                [totalLabel]="'Total Demos Booked'" [xAxisShowOnlyFirstLast]="true" [showBgRect]="false"
                [useStripesForTop]="true" [padding]="0.45" [legendMarginTop]="15"
                [margins]="{ top: 30, right: 10, bottom: 55, left: 40 }" class="w-full h-full block">
              </app-stacked-bar>
            </div>
            }
          </div>
        </div>
      </div>
      }
      @if (showSection(SectionId.DEAL_REALIZATION)) {
      <div class="relative group" [ngClass]="getSectionColClass(SectionId.DEAL_REALIZATION)"
        [style.order]="sectionOrder(SectionId.DEAL_REALIZATION)">
        <ng-container *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.DEAL_REALIZATION }"></ng-container>
        <div [ngClass]="metricSectionShellClass()">
          <ng-container
            *ngTemplateOutlet="clampedH3; context: { text: 'Deal Realization Performance', classes: chartHeadingClass }"></ng-container>
          <p class="text-[13px] text-gray-500 dark:text-gray-400 mb-4 font-medium">Deals created vs claimed</p>
          <div class="flex-1 relative min-h-0">
            @if (loadingDealRealization) {
            <app-individual-toaster [message]="'Loading deal realization...'" [position]="'top-center'" [type]="'info'"
              [loaderType]="'dark'" [fontSize]="'24px'"></app-individual-toaster>
            } @else if (!hasDealRealizationData) {
            <div class="absolute inset-0 flex flex-col items-center justify-center text-slate-400 dark:text-slate-500">
              <app-icon-v2 name="database" [size]="48" class="mb-3 opacity-50"></app-icon-v2>
              <p class="text-sm font-medium">No data available</p>
              <p class="text-xs mt-1">There are no records for this period.</p>
            </div>
            } @else {
            <div class="w-full h-full flex items-center justify-center">
              <div class="w-full h-[300px]">
                <app-multiple-bar [data1]="dealCreatedData" [data2]="dealClaimedData"
                  [legendData]="[{ label: 'Deals Created', color: '#3b82f6' }, { label: 'Deals Claimed', color: '#22d3ee' }]"
                  [colors]="{ data1: '#3b82f6', data2: '#22d3ee', data3: '', data4: '' }" [showDynamicxAxisLabel]="true"
                  [addGradient]="false" [showBarValues]="true" [barClusterPixel]="28" [legendPosition]="'center'"
                  [legendGap]="120" [margin]="{ top: 30, right: 20, bottom: 55, left: 30 }" [valueType]="'number'"
                  [xAxisShowOnlyFirstLast]="true" [showBgRect]="false" [barHeightRatio]="1" [height]="280"
                  [legendIconType]="'circle'" [useStandardizedScaling]="true" class="w-full h-full block">
                </app-multiple-bar>
              </div>
            </div>
            }
          </div>
        </div>
      </div>
      }

      @if (showSection(SectionId.MARKETING_OVERVIEW)) {
      <div class="relative group" [ngClass]="getSectionColClass(SectionId.MARKETING_OVERVIEW)"
        [style.order]="sectionOrder(SectionId.MARKETING_OVERVIEW)">
        <ng-container
          *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.MARKETING_OVERVIEW }"></ng-container>
        <div [ngClass]="overviewSectionShellClass()">
          <div class="mb-6 shrink-0">
            <ng-container
              *ngTemplateOutlet="clampedH3; context: { text: 'Marketing Performance Overview', classes: summaryHeadingClass }"></ng-container>
            <p class="text-[13px] text-gray-500 dark:text-gray-400 mt-1 font-medium">Key spend and conversion indicators
            </p>
          </div>
          <div class="flex-1 relative min-h-0">
            @if (loadingMarketingOverview) {
            <div
              class="absolute inset-0 bg-white/50 dark:bg-surface-2/50 backdrop-blur-[1px] flex items-center justify-center z-10">
              <div class="w-8 h-8 border-4 border-slate-200 border-t-slate-500 rounded-full animate-spin"></div>
            </div>
            }
            <div class="flex flex-col space-y-4" [class.opacity-20]="loadingMarketingOverview">
              @for (item of marketingPerformanceMetrics; track item.label) {
              <div
                class="flex items-center justify-between border-b border-gray-50 dark:border-gray-700/50 pb-3 last:border-0 last:pb-0">
                <span class="text-[13px] text-gray-400 dark:text-gray-400 font-medium">{{ item.label }}</span>
                <span class="text-[14px] {{ item.valueColorClass }} font-bold">{{ item.value }}</span>
              </div>
              }
            </div>
          </div>
        </div>
      </div>
      }
      @if (showSection(SectionId.EXECUTIVE_SUMMARY)) {
      <div class="relative group" [ngClass]="getSectionColClass(SectionId.EXECUTIVE_SUMMARY)"
        [style.order]="sectionOrder(SectionId.EXECUTIVE_SUMMARY)">
        <ng-container
          *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.EXECUTIVE_SUMMARY }"></ng-container>
        <div [ngClass]="overviewSectionShellClass()">
          <div class="mb-6 shrink-0">
            <ng-container
              *ngTemplateOutlet="clampedH3; context: { text: 'Executive Performance Summary', classes: summaryHeadingClass }"></ng-container>
            <p class="text-[13px] text-gray-500 dark:text-gray-400 mt-1 font-medium">Aggregate growth, marketing, and
              revenue metrics</p>
          </div>
          <div class="flex-1 relative min-h-0">
            @if (loadingExecutiveSummary) {
            <div
              class="absolute inset-0 bg-white/50 dark:bg-surface-2/50 backdrop-blur-[1px] flex items-center justify-center z-10">
              <div class="w-8 h-8 border-4 border-slate-200 border-t-slate-500 rounded-full animate-spin"></div>
            </div>
            }
            <div class="flex flex-col space-y-3" [class.opacity-20]="loadingExecutiveSummary">
              @for (item of executivePerformanceMetrics; track item.label) {
              <div
                class="flex items-center justify-between border-b border-gray-50 dark:border-gray-700/50 pb-2 last:border-0 last:pb-0">
                <span class="text-[13px] text-gray-400 dark:text-gray-400 font-medium">{{ item.label }}</span>
                <span class="text-[14px] {{ item.valueColorClass }} font-bold">{{ item.value }}</span>
              </div>
              }
            </div>
          </div>
        </div>
      </div>
      }

    </div>
  </div>

  @if (!mixedMode()) {
  <app-dashboard-layout-editor [open]="isLayoutEditorOpen()" [items]="editorItems()"
    [visibleCount]="editorVisibleCount()" (closed)="closeLayoutEditor()" (applied)="applyLayoutEditor()"
    (resetDefaults)="resetLayoutEditorToDefaults()" (cardDropped)="onEditorCardDrop($any($event))"
    (visibilityToggled)="toggleEditorCardVisibility($any($event))"
    (colSpanDecreased)="decreaseEditorCardColSpan($any($event))"
    (colSpanIncreased)="increaseEditorCardColSpan($any($event))" (autoAdjustWidth)="autoAdjustEditorWidths()" />
  }

</div>

<ng-template #clampedH2 let-text="text" let-classes="classes">
  <app-tooltip [content]="text" [disabled]="!isClipped(headingElement)" [block]="true" [useFixedStrategy]="true"
    className="max-w-full w-full" triggerClassName="max-w-full w-full" [position]="'top'">
    <h2 #headingElement [class]="classes">{{ text }}</h2>
  </app-tooltip>
</ng-template>

<ng-template #clampedH3 let-text="text" let-classes="classes">
  <app-tooltip [content]="text" [disabled]="!isClipped(headingElement)" [block]="true" [useFixedStrategy]="true"
    className="max-w-full w-full" triggerClassName="max-w-full w-full" [position]="'top'">
    <h3 #headingElement [class]="classes">{{ text }}</h3>
  </app-tooltip>
</ng-template>

<ng-template #cardTemplate let-card>
  <div [ngClass]="kpiCardShellClass()">
    @if (card.loading) {
    <div class="animate-pulse flex gap-3 [@media(max-height:620px)]:gap-2 w-full h-full">
      <div
        class="w-[42px] h-[42px] [@media(max-height:700px)]:w-10 [@media(max-height:700px)]:h-10 [@media(max-height:620px)]:w-9 [@media(max-height:620px)]:h-8 rounded-xl [@media(max-height:620px)]:rounded-lg bg-slate-100 dark:bg-slate-700/60 shrink-0">
      </div>
      <div class="flex flex-col flex-1 justify-between py-1 [@media(max-height:620px)]:py-0.5">
        <div
          class="h-4 w-20 [@media(max-height:620px)]:w-16 [@media(max-height:620px)]:h-3 bg-slate-100 dark:bg-slate-700/50 rounded shadow-sm">
        </div>
        <div class="flex items-end justify-between mt-2 [@media(max-height:620px)]:mt-1 min-w-0">
          <div
            class="h-8 [@media(max-height:620px)]:h-6 w-16 [@media(max-height:620px)]:w-12 bg-slate-100 dark:bg-slate-700/60 rounded-lg shadow-sm">
          </div>
          @if (card.trend) {
          <div
            class="h-5 [@media(max-height:620px)]:h-4 w-12 [@media(max-height:620px)]:w-10 bg-slate-100 dark:bg-slate-700/40 rounded-full shadow-sm shrink-0 ml-1">
          </div>
          }
        </div>
      </div>
    </div>
    } @else {
    <div class="flex gap-4 [@media(max-height:620px)]:gap-3 items-start h-full w-full">
      <div
        class="w-[42px] h-[42px] [@media(max-height:700px)]:w-10 [@media(max-height:700px)]:h-10 [@media(max-height:620px)]:w-9 [@media(max-height:620px)]:h-9 rounded-xl [@media(max-height:620px)]:rounded-lg flex items-center justify-center text-white shrink-0"
        [ngClass]="card.bgColorClass">
        <div
          class="flex items-center justify-center scale-100 [@media(max-height:700px)]:scale-[0.85] [@media(max-height:620px)]:scale-[0.80]">
          <app-icon-v2 [name]="card.icon" size="22"></app-icon-v2>
        </div>
      </div>
      <div class="flex flex-col flex-1 justify-between min-w-0 h-full">
        <div [class]="cardTitleWrapperClass">
          <app-tooltip [content]="card.title" [disabled]="!isClipped(titleElement)" [block]="true"
            [useFixedStrategy]="true" className="max-w-full w-full min-w-0" triggerClassName="max-w-full w-full min-w-0"
            [position]="'top'">
            <div #titleElement [class]="cardTitleClass">{{ card.title }}</div>
          </app-tooltip>
        </div>
        <div
          class="flex items-end justify-between mt-2 [@media(max-height:700px)]:mt-1 [@media(max-height:620px)]:mb-0.5 min-w-0 w-full">
          <div [class]="cardValueWrapperClass">
            <app-tooltip [content]="card.value" [disabled]="!isClipped(valueElement)" [block]="true"
              [useFixedStrategy]="true" className="max-w-full w-full min-w-0"
              triggerClassName="max-w-full w-full min-w-0" [position]="'top'">
              <div #valueElement [class]="cardValueClass">
                {{ card.value }}
              </div>
            </app-tooltip>
          </div>
          <div class="text-right flex flex-col items-end shrink-0" *ngIf="card.trend">
            <div [class]="cardTrendValueClass + ' ' + (card.trend.textColorClass || 'text-gray-900 dark:text-white')">
              <div
                class="flex items-center justify-center scale-100 [@media(max-height:620px)]:scale-75 mr-1 [@media(max-height:620px)]:mr-0">
                <app-icon-v2 *ngIf="card.trend.direction === 'up'" name="trending-up" size="14"></app-icon-v2>
                <app-icon-v2 *ngIf="card.trend.direction === 'down'" name="trending-down" size="14"></app-icon-v2>
              </div>
              {{ card.trend.value }}
            </div>
            <div [class]="cardTrendLabelClass" *ngIf="card.trend.label">
              {{ card.trend.label }}
            </div>
          </div>
        </div>
      </div>
    </div>
    }
  </div>
</ng-template>